import { API_BASE_URL, ensureCsrfToken } from "./apiClient";
import { clientPortalRequest } from "./clientPortalFetch";

export function listOpportunityDocuments(clientViewId, opportunityId) {
  return clientPortalRequest(`/views/${clientViewId}/opportunities/${opportunityId}/documents`);
}

export async function uploadOpportunityDocument(clientViewId, opportunityId, file) {
  const token = await ensureCsrfToken();
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(
    `${API_BASE_URL}/api/client/views/${clientViewId}/opportunities/${opportunityId}/documents`,
    {
      method: "POST",
      headers: { "X-CSRF-Token": token },
      body: formData,
      credentials: "include",
    }
  );

  const body = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(body?.message || `Upload failed (${response.status})`);
  }
  return body;
}

export function deleteOpportunityDocument(clientViewId, opportunityId, documentId) {
  return clientPortalRequest(
    `/views/${clientViewId}/opportunities/${opportunityId}/documents/${documentId}`,
    { method: "DELETE" }
  );
}
